import React, {useEffect, useState} from "react";
import axios from "axios";
import {DataGrid} from "@mui/x-data-grid";
import {baseUrl} from "../Univ.js";
function AuditTrailList() {
    const [rows, setRows] = useState([]);
    useEffect(() => {
        fetchData();
    }, []);
    const fetchData = () => {
        axios.get(`${baseUrl}audit-trail/`)
            .then(res => {
                const data = res.data.map(item => ({
                    id: item.id,
                    module: item.module,
                    action: item.action,
                    record_id: item.record_id,
                    user: item.user,
                    old_value: item.old_value,
                    new_value: item.new_value,
                    remarks: item.remarks,
                    add_date: item.add_date,
                    add_time: item.add_time,
                }));
                setRows(data);
            })
            .catch(err => console.log(err));
    };
    const columns = [
        {field: "id", headerName: "ID", width: 70},
        {field: "module", headerName: "Module", width: 120},
        {field: "action", headerName: "Action", width: 140},
        {field: "record_id", headerName: "Record ID", width: 110},
        {field: "user", headerName: "User", width: 150},
        {field: "old_value", headerName: "Old Value", width: 200},
        {field: "new_value", headerName: "New Value", width: 200},
        {field: "remarks", headerName: "Remarks", width: 180},
        {field: "add_date", headerName: "Date", width: 110},
        {field: "add_time", headerName: "Time", width: 110},
    ];
    return (
        <section className="container mt-4">

            <h3 className="text-center bg-light p-2">
                Audit Trail
            </h3>

            <div style={{height: 600, width: "100%"}} className="mt-3">

                <DataGrid
                    sx={{
                        boxShadow: 4,
                        border: 4,
                        borderColor: 'primary.light',
                        '& .MuiDataGrid-cell:hover': {
                            color: 'primary.main',
                        },
                    }}
                    autoHeight
                    rows={rows}
                    columns={columns}
                    pageSize={10}
                    rowsPerPageOptions={[10, 25, 50]}
                    initialState={{
                        sorting: {
                            sortModel: [{field: "id", sort: "desc"}],
                        },
                    }}
                />

            </div>

        </section>
    );
}
export default AuditTrailList;